import {useEffect} from 'react';

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: React.RefObject<T>,
  handler: () => void,
  mouseAction?: keyof DocumentEventMap,
): void {
  useEffect(() => {
    const currentRef = ref.current;

    document.addEventListener(mouseAction ? mouseAction : 'click', e => {
      if (ref?.current && !ref?.current.contains(e.target as Node)) {
        handler();
      }
    });

    return () => {
      document.removeEventListener('click', e => {
        if (currentRef && !currentRef?.contains(e.target as Node)) {
          handler();
        }
      });
    };
  });
}
export default useOnClickOutside;
